import React, { useContext, useEffect, useRef, useState } from 'react'
import { BiHelpCircle } from 'react-icons/bi'
import { MdNotificationsActive, MdDashboardCustomize, MdArrowDropDown } from 'react-icons/md'
import { Link, useLocation, useNavigate } from 'react-router-dom'
import logo from '../../../assets/biztrade_logo/logo.png'
import { Auth, UserInfo } from '../../../contexts/allContext'
import { apiV1, homeUrl, sellerUrl } from '../../../utils/api'
import { svgs } from '../../../utils/findSvgs/findSvgs'
import classes from './Navbar.module.css'

export default function Navbar() {
    const { stateUser, dispatchUser } = useContext(UserInfo)
    const { stateAuth, dispatchAuth } = useContext(Auth)
    const userInfo = stateUser.info
    const token = stateAuth.token

    const [companyLogo, setCompanyLogo] = useState(null)
    const [openPopUp, setOpenPopUp] = useState(false)
    const [toggle, setToggle] = useState(true)

    const location = useLocation()
    const navigate = useNavigate()
    const modalRef = useRef()

    useEffect(() => {
        const closeHandler = (e) => {
            if (modalRef.current && !modalRef.current.contains(e.target)) {
                setOpenPopUp(false)
            }
        }
        document.addEventListener('click', closeHandler)
        return () => document.removeEventListener('click', closeHandler)
    }, [])

    const handleLogout = () => {
        dispatchAuth({ type: 'remove' })
        dispatchUser({ type: 'remove' })
        navigate('/')
    }

    const handleMenuItemClick = (item) => {
        if (item.action === 'logout') handleLogout()
        else navigate(item.path)
    }

    const handleSeller = () => {
        if (userInfo.role_name === 'seller') {
            setToggle(false)
            window.location.href = `${sellerUrl}/${token}`
        } else {
            alert('You are not authorized to access seller dashboard.')
        }
    }

    useEffect(() => {
        if (userInfo.id) {
            fetch(`${apiV1}/companies/${userInfo.id}`)
                .then((res) => res.json())
                .then((data) => {
                    const img = data.ImgLogo?.image_string
                    if (img) setCompanyLogo(`${apiV1}/images/logo/${img}`)
                })
                .catch(console.error)
        }
    }, [userInfo.id])

    const menuItems = [
        {
            id: 1,
            path: '#',
            icon: svgs.settings,
            text: 'Settings',
        },
        { id: 2, path: '#', icon: svgs.logout, text: 'Logout', action: 'logout' },
    ]

    return (
        <div className={classes.navbar}>
            <Link to={homeUrl}>
                <div className={classes.navbarLeft}>
                    <img src={logo} alt="Logo" />
                </div>
            </Link>

            <div className={classes.navbarRight}>
                <div className={classes.switch}>
                    <div className={toggle ? classes.activeSwitch : classes.inactiveSwitch}>Buyer</div>
                    <div
                        onClick={() => toggle && handleSeller()}
                        className={!toggle ? classes.activeSwitch : classes.inactiveSwitch}>
                        Seller
                    </div>
                </div>

                <div className={classes.sectiontab}>
                    <BiHelpCircle className={classes.iconStyle} />
                    <div className={classes.notification} current-count="0">
                        <MdNotificationsActive className={classes.iconStyle} />
                    </div>
                    <MdDashboardCustomize className={classes.iconStyle} />
                </div>

                <div className={classes.profile} ref={modalRef} onClick={() => setOpenPopUp((v) => !v)}>
                    <div className={classes.layout}>
                        {companyLogo ? <img src={companyLogo} alt="Company Logo" /> : ''}
                        <h5>{userInfo.name}</h5>
                    </div>
                    <div>{svgs.downArrow}</div>

                    <div className={`${classes.popUp} ${openPopUp ? classes.active : ''}`}>
                        <div className={classes.welcomeMessage}>
                            <h4>Good Morning!</h4>
                            <span>{userInfo.name}</span>
                        </div>
                        <ul className={classes.menuItems}>
                            {menuItems.map((item) => (
                                <li
                                    key={item.id}
                                    className={`${classes.linkItem} ${
                                        location.pathname === item.path ? classes.activeItem : classes.inactiveItem
                                    }`}
                                    onClick={() => handleMenuItemClick(item)}>
                                    <Link to={item.path}>
                                        {item.icon}
                                        {item.text}
                                    </Link>
                                </li>
                            ))}
                        </ul>
                    </div>
                </div>
            </div>
        </div>
    )
}
